import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/tipsy-ui/tipsy-ui/components/characters/FAQList.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tipsy-ui/tipsy-ui/icons/icon_facebook.svg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tipsy-ui/tipsy-ui/icons/icon_ins.svg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tipsy-ui/tipsy-ui/icons/icon_tiktok.svg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tipsy-ui/tipsy-ui/icons/icon_youtube.svg");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tipsy-ui/tipsy-ui/node_modules/.pnpm/next@14.2.23_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/tipsy-ui/tipsy-ui/node_modules/.pnpm/next@14.2.23_@babel+core@7.29.7_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
